import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSubscriptionPlans, removeSubscriptionPlan } from '../redux/slices/subscriptionPlanSlice';
import '../styles/TableStyles.css';

function SubscriptionPlanList() {
  const dispatch = useDispatch();
  const { plans, loading, error } = useSelector((state) => state.subscriptionPlans);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  React.useEffect(() => {
    dispatch(fetchSubscriptionPlans());
  }, [dispatch]);

  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this plan?')) {
      dispatch(removeSubscriptionPlan(id));
    }
  };

  // Calculate pagination
  const totalPages = Math.ceil(plans.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedPlans = plans.slice(startIndex, endIndex);

  const handleNextPage = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div className="table-container">
      <h2>Subscription Plans</h2>
      {plans.length === 0 ? (
        <p className="no-data">No subscription plans found</p>
      ) : (
        <>
          {/* Top Pagination Controls */}
          <div className="pagination-controls">
            <button 
              onClick={handlePrevPage} 
              disabled={currentPage === 1}
              className="pagination-btn"
              type="button"
              title="Previous page"
            >
              &lt;
            </button>
            <span className="pagination-info">
              {currentPage}/{totalPages}
            </span>
            <button 
              onClick={handleNextPage} 
              disabled={currentPage >= totalPages}
              className="pagination-btn"
              type="button"
              title="Next page"
            >
              &gt;
            </button>
          </div>

          <table className="modern-table">
            <thead>
              <tr>
                <th>Plan Name</th>
                <th>Price (₹)</th>
                <th>Duration (Months)</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {paginatedPlans.map((plan) => (
                <tr key={plan.plan_id}>
                  <td>{plan.name}</td>
                  <td>₹{parseFloat(plan.price).toFixed(2)}</td>
                  <td>{plan.duration_months} months</td>
                  <td>
                    <button
                      className="delete-btn"
                      onClick={() => handleDelete(plan.plan_id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Bottom Pagination Controls */}
          <div className="pagination-controls">
            <button 
              onClick={handlePrevPage} 
              disabled={currentPage === 1}
              className="pagination-btn"
              type="button"
              title="Previous page"
            >
              &lt;
            </button>
            <span className="pagination-info">
              {currentPage}/{totalPages}
            </span>
            <button 
              onClick={handleNextPage} 
              disabled={currentPage >= totalPages}
              className="pagination-btn"
              type="button"
              title="Next page"
            >
              &gt;
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default SubscriptionPlanList;
